var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"ui-loading-overlay"},[_c('div',{staticClass:"ui-loading-box"},[_c('div',{staticClass:"ui-loading-spinner"}),_c('p',{staticClass:"ui-loading-text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }